import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import VueI18n from 'vue-i18n';
import messages from '@/lang/messages';
import VueToastr from 'vue-toastr';
import Multiselect from 'vue-multiselect';
import VueObserveVisibility from 'vue-observe-visibility';
import VueTheMask from 'vue-the-mask';
import moment_timezone from 'moment-timezone';
import VTooltip from 'v-tooltip';
import { Settings } from 'luxon';
import './utils/filters';

Settings.defaultLocale = 'pt-BR';
Vue.use(VueToastr);
Vue.use(VueI18n);
Vue.use(VueObserveVisibility);
Vue.use(VueTheMask);
Vue.use(VTooltip);
Vue.component('multiselect', Multiselect);

Vue.prototype.$moment = moment_timezone;

const currentLocale = localStorage.getItem('systemLanguage') || 'pt-BR';

const i18n = new VueI18n({
	locale: currentLocale,
	fallbackLocale: 'pt-BR',
	messages,
});

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
